import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../../services/api-services';
import { firstValueFrom } from 'rxjs';
import { AuthSubscriptionService } from 'lib/Vestra.shared';

@Injectable({ providedIn: 'root' })
export class AnyGuardService {
    constructor(private authenticationService: AuthenticationService, private authSubscriptionService: AuthSubscriptionService) {}

    canActivate(): Promise<boolean> | boolean {
        if (this.authenticationService.isUserAuthenticated()) {
            return this.authenticationService.isAnyLevel();
        }

        return firstValueFrom(this.authSubscriptionService.authChanged)
            .then(isAuthenticated => {
                if (!isAuthenticated) {
                    return false;
                }
                return this.authenticationService.isAnyLevel();
            })
            .catch((error: any) => {
                return false;
            });
    }
}

export const AnyGuard: CanActivateFn = (route, state): Promise<boolean> | boolean => {
    return inject(AnyGuardService).canActivate();
};
